import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {filter, take} from "rxjs/operators";
import {FORM_ACTIONS} from "@ispm/dynamic-form/store/form.actions";
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import * as _ from 'lodash';

export interface IFormDataReplacementDescriptor {
   property: string;
   name: string;
   overrides: any;
   defaultFrom?: number;
}

@Injectable()
export class FormDataSubstitutionService {

  private formStore$: any;

  constructor(protected formHandler: FormHandlerService,
              private store: Store<IgenomicsState>
              ) {
    this.formStore$ = store.select('forms');
  }


  public overrideData( objectSrc:Object, formId:string, replacementDescriptors: IFormDataReplacementDescriptor[]): any {

    this.formHandler.getStoredFormById(formId)
      .pipe(
        filter(form => !!form),
        take(1)
      )
      .subscribe((data => {
        replacementDescriptors.forEach(replaceItem => {
          this.replaceFormData(objectSrc, data, replaceItem);
        });
        this.store.dispatch({
          type: FORM_ACTIONS.ADD_FORM,
          payload: {
            name: formId,
            inputs: _.cloneDeep(data)
          }
        });
      }));
  }

  private replaceFormData(objectSrc: Object, data: any, replacementDescriptor: IFormDataReplacementDescriptor) {
    data.forEach(formInput => {
      if (formInput.name === replacementDescriptor.name && _.has(objectSrc, replacementDescriptor.property) && _.has(replacementDescriptor, 'overrides')) {
        let newValues = _.get(objectSrc, replacementDescriptor.property);
        _.set(formInput, replacementDescriptor.overrides, newValues);
        if(_.has(replacementDescriptor, 'defaultFrom')){
          let index = _.get(replacementDescriptor, 'defaultFrom', 0);
          if(newValues instanceof  Array && newValues.length > index) {
            _.set(formInput, 'defaultValue', newValues[index]);
          }
          else {
            _.set(formInput, 'defaultValue', '');
          }
        }
      }
    });
  }
}
